export const BOOLEAN_DEFAULTS: Record<string, boolean | null> = {
  dropped: null,
  callable: null,
  perpetual: null,
  issuedByHoldingCompany: null,
  issuedByOperatingCompany: null,
  includeUsIgNonCountables: false,
};

export const EXCLUDE_RESET: Record<string, Record<string, unknown>> = {
  excludedCurrencyIds: { excludedCurrencyIds: [], isCurrencyExcluded: false },
  excludedTickerCompanyIds: { excludedTickerCompanyIds: [], isTickerExcluded: false },
  excludedRatingGroupIds: { excludedRatingGroupIds: [] },
  excludedRatingAgencyIds: { excludedRatingAgencyIds: [] },
  excludedLeadIds: { excludedLeadIds: [], isLeadsExcluded: false, includedLeadRoleIds: [] },
  excludedUseOfProceedsIds: { excludedUseOfProceedsIds: [], isUseOfProceedsExcluded: false },
  excludedTenor: { excludedTenorFrom: null, excludedTenorTo: null, isTenorExcluded: false },
  excludedAdditionalFilters: { excludedAdditionalFilters: [], isAdditionalFiltersExcluded: false },
};

export const REMOVE_SIDE_EFFECTS: Record<string, string[]> = {
  includedLeadIds: ['includedLeadRoleIds'],
  excludedLeadIds: ['includedLeadRoleIds'],
};
